export default __webpack_public_path__ + "static/pixelmap-572a6ef0a9298bac6dffe85db517f6ea.jpg";